@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
@if (displayMultiSelectionText) {
    <div class="ogp-market-help">
        <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="multiSelectionHelpText" />
    </div>
}
<div
    class="option-group-container bet-builder-goal-scorer-container"
    [style.--option-group-rows]="visibleOptions().length"
    [ngClass]="[isSingleRowOfOptions() ? 'ht-of-single-row-options' : '', scoreOptionsClass()]">
    <ng-container *rxFor="let group of optionsToDisplay$; strategy: renderStrategy$; trackBy: trackGroup; renderCallback: groupsRendered$">
        <div class="attribute-key">
            <span class="attribute-key-ellipsis">{{ group.attribute }}</span>
        </div>
        <ng-container *ngFor="let option of group.options; trackBy: trackOption">
            @if (option) {
                <ms-bet-builder-option
                    [tracking]="{ source: tracking, moduleType: trackingModuleType }"
                    [option]="option"
                    [optionGroup]="optionGroup"
                    [showMarketAttribute]="showMarketAttribute"
                    [event]="event"
                    [sourceOfPick]="sourceOfPick" />
            } @else {
                <div class="option option-pick">
                    <div class="offline">
                        <div class="value">-</div>
                    </div>
                </div>
            }
        </ng-container>
    </ng-container>
</div>
@if (!showAllOptions()) {
    <div class="show-more-less-button" [ngClass]="{ expanded: !isCollapsed() }" (click)="expand()">
        {{ isCollapsed() ? this.sitecore.event.ShowMore : this.sitecore.event.ShowLess }}
        <vn-icon name="theme-right" size="12" class="right-icon" />
    </div>
}
